// Copyright (c) 2022 by Move Closer

import { ModuleContentResolver } from '../../contexts'

import {
  ReviewsTeaserModuleContent,
  ReviewsTeaserModuleContentInput
} from './ReviewsTeaser.contracts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const resolveReviewsTeaserModuleContent: ModuleContentResolver<ReviewsTeaserModuleContentInput, ReviewsTeaserModuleContent> =
  async (input: ReviewsTeaserModuleContentInput): Promise<ReviewsTeaserModuleContent> => {
    return {
      ...input
    }
  }
